import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IdentificationComponent } from './identification.component';
import { SharedModule } from '@shared/shared.module';
import { IdentificationRoutingModule } from './identification-routing.module';
import { MatCoreModule } from '@shared/material/mat-core.module';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { IdentificationCardItemComponent } from './identification-card-item/identification-card-item.component';
import {MatSelectModule} from '@angular/material/select';
import { IdentificationInfoComponent } from './identification-info/identification-info.component';
import {MatSnackBarModule} from '@angular/material/snack-bar';



@NgModule({
  declarations: [
    IdentificationComponent, 
    IdentificationCardItemComponent,
    IdentificationInfoComponent
    ],
  imports: [
    CommonModule,
    SharedModule,
    IdentificationRoutingModule,
    MatCoreModule,
    MatDatepickerModule,
    MatSelectModule,
    MatSnackBarModule
  ],


})
export class IdentificationModule { }
